import us from "../assets/images/flags/us.svg";
import kw from "../assets/images/flags/kw.svg";

export const Languages = {
  en: {
    label: "English",
    flag: us,
    dir: "ltr",
  },
  ar: {
    label: "عربي",
    flag: kw,
    dir: "rtl",
  },
};
